import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import api from "../../api";
import { resetPassword as resetPasswordURL } from "../../config";
import { IInitialSliceState } from "../../common/types/commonTypes";

const RESET_PASSWORD = "resetPassword";

const initialState: IInitialSliceState = {
  msg: null,
  status: Status.IDLE,
  error: null,
};

interface IResetPasswordResponse {
  message:string,
}

export const resetPassword = createAsyncThunk(
  RESET_PASSWORD,
  async ({ email, password }: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const resetPasswordResponse = await api.post<IResetPasswordResponse>(
        `${resetPasswordURL}`,
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      return resetPasswordResponse.data;
    } catch (error: any) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ message: error.message });
    }
  }
);

const resetPasswordSlice = createSlice({
  name: RESET_PASSWORD,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = action.payload?.message ?? null;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = (action.payload as any)?.message || action.error.message || "Something went wrong!";
      });
  },
});

type Selector = {
  resetPasswordApi: ReturnType<typeof resetPasswordSlice.reducer>;
};

export const selector = (store: Selector) => store["resetPasswordApi"];
export default resetPasswordSlice.reducer;
